import { type ReactNode } from "react";

import { Box, Typography } from "@mui/material";

type AllocationCalculationItemBoxProps = {
  icon: ReactNode;
  text: ReactNode;
};

const AllocationCalculationItemBox = ({ icon, text }: AllocationCalculationItemBoxProps) => (
  <Box sx={{ display: "flex", gap: 2 }}>
    {icon}
    <Typography variant="body1" sx={{ fontSize: "0.875rem" }}>
      {text}
    </Typography>
  </Box>
);

export default AllocationCalculationItemBox;
